module.exports = __webpack_public_path__ + "media/customizations/regencyateverrange/back-4b78571e1fb7e7d7916c549cd8421cc1.jpg";